@let isClickable = (isOnAttendantConsole$ | async) ?? false;
@let pinnedServices = pinnedServices$ | async;
@let toggleUserEnabilityTeamIds = toggleUserEnabilityTeamIds$ | async;

@if (pinnedServices?.length) {
  <div class="header-bar-pinned-services">
    @for (service of pinnedServices; track service.teamId) {
      <nimbus-user-team
        class="header-bar-pinned-service"
        [variant]="UserTeamVariant.Pinned"
        [team]="service"
        [clickable]="isClickable"
        [withCheck]="!toggleUserEnabilityTeamIds?.has(service.teamId)"
        (teamClick)="onPinnedClick(service)"
      >
        <button
          type="button"
          class="header-bar-pinned-service-unpin"
          [attr.aria-label]="TranslationKeys.HeaderBarUnpinService | translate"
          (click)="unpin(service, $event)"
        >
          <i class="header-bar-pinned-service-pin" [nimbusIcon]="ICONS.STAR"></i>
          <nimbus-tooltip
            [text]="TranslationKeys.HeaderBarUnpinService | translate"
            [ariaLabel]="TranslationKeys.HeaderBarUnpinService | translate"
          ></nimbus-tooltip>
        </button>
      </nimbus-user-team>
    }
  </div>
}
